const icon1 =
  "https://winpeforum.com/assets/elements/Manisha_photo_1_Jan2020a.png";
const icon2 =
  "https://winpeforum.com/assets/elements/Manisha_photo_1_Jan2020a.png";
const icon3 = "https://winpeforum.com/assets/elements/padmajaruparel.jpg";
const icon4 = "https://winpeforum.com/assets/elements/Alagappan_Murugappan.png";
const icon5 = "https://winpeforum.com/assets/elements/SAN_0176_edit.png";
const icon6 = "https://winpeforum.com/assets/elements/Bala_c_p.png";
const icon7 = "https://winpeforum.com/assets/elements/nupur_garg.jpg";
const icon8 = "https://winpeforum.com/assets/elements/Bala_c_p.png";
const icon9 =
  "https://winpeforum.com/assets/elements/Nupur_Garg_profile_piC%20300X292.jpg";
  const icon10 =
  "https://winpeforum.com/assets/elements/pearl.jpg";
  const icon11 = "https://winpeforum.com/assets/elements/sushma.jpg";
  const icon12 = "https://winpeforum.com/assets/elements/Mitchell-Truwit.jpg  ";
  const icon13 = "https://winpeforum.com/assets/elements/soumyaa.jpg";
  const icon14 = "https://winpeforum.com/assets/elements/Priya-Rajan.jpg";
  const icon15 = "https://winpeforum.com/assets/elements/NehaKant.jpg";
  const icon16 = "https://winpeforum.com/assets/elements/HardikaShah.jpg";
  const icon17 = "https://winpeforum.com/assets/elements/Suhela.jpg";
const insightsConstants = [
  {
    id: 25,
    name: "",
    lname: "Alicorn Leadership Summit 2021-22",
    post: "",
    date: "1 March 2022",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS"],
    typee:
      "Alicorn Leadership Summit 2021-22",
    ltitle: "Investing for the Future",
    skey:
      "Alicorn Leadership Summit 2021-22",
    url: "/InvestingForTheFuture",
    imgUrl: icon16,
  },
  {
    id: 25,
    name: "",
    lname: "International Women's Day Series",
    post: "",
    date: "8 March 2022",
    type: "INTERVIEW",
    itype: ["INTERVIEW"],
    typee:
      "Winpe-BCG",
    ltitle: "He#BreakTheBias",
    skey:
      "He#BreakTheBias",
    url: "/HeBreakTheBias",
    imgUrl: icon16,
  },
  {
    id: 25,
    name: "",
    lname: "Winpe-BCG ",
    post: "",
    date: "1 March 2022",
    type: "REPORT",
    itype: ["REPORT"],
    typee:
      "Winpe-BCG",
    ltitle: "Report on 'Closing the Gender Gap in Investing'",
    skey:
      "Report on 'Closing the Gender Gap in Investing'",
    url: "/ClosingtheGenderGapinInvesting",
    imgUrl: icon16,
  },
  {
    id: 25,
    name: "",
    lname: "Suhela Khan of UN Women",
    post: "",
    date: "18 February 2022",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "Suhela has an extensive experience in management of large-scale transformational programmes on women's economic empowerment.",
    ltitle: "Champion of Change",
    skey:
      "Suhela has an extensive experience in management of large-scale transformational programmes on women's economic empowerment.",
    url: "/SuhelaKhan",
    imgUrl: icon17,
  },
  {
    id: 25,
    name: "",
    lname: "Alicorn Leadership Summit 2021-22",
    post: "",
    date: "28 January 2022",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS"],
    typee:
      "Alicorn Leadership Summit 2021-22",
    ltitle: "Global Perspectives: Diversity in Leadership",
    skey:
      "Alicorn Leadership Summit 2021-22",
    url: "/GlobalPerspectivesDiversityinLeadership",
    imgUrl: icon16,
  },
  {
    id: 25,
    name: "",
    lname: "Hardika Shah of Kinara Capital",
    post: "",
    date: "21 January 2022",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS"],
    typee:
      "Hardika Shah, Founder & CEO, Kinara Capital",
    ltitle: "For, Of and By an Entrepreneur",
    skey:
      "Hardika Shah, Founder & CEO, Kinara Capital",
    url: "/HardikaShah",
    imgUrl: icon16,
  },
  {
    id: 25,
    name: "",
    lname: "Alicorn Leadership Summit 2021-22",
    post: "",
    date: "16 December 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS"],
    typee:
      "Alicorn Leadership Summit 2021-22",
    ltitle: "Leaders Today, Icons Tomorrow",
    skey:
      "Alicorn Leadership Summit 2021-22",
    url: "/LeadersTodayIconsTomorrow",
    imgUrl: icon16,
  },
  {
    id: 25,
    name: "",
    lname: " ",
    post: "",
    date: "26 November 2021",
    type: "INFOGRAPHICS",
    itype: [ "INFOGRAPHICS"],
    typee:  "The final infographic in this series brings experience, practical insights and secondary research together to suggest workable solutions to kickstart the journey towards building gender balance.",
    ltitle: "Achieving Gender Diversity 1.0",
    skey: "The final infographic in this series brings experience, practical insights and secondary research together to suggest workable solutions to kickstart the journey towards building gender balance.",
    url: "/AchievingGenderDiversity",
    imgUrl: icon12,
  },
  {
    id: 25,
    name: "",
    lname: " ",
    post: "",
    date: "12 November 2021",
    type: "INFOGRAPHICS",
    itype: [ "INFOGRAPHICS"],
    typee:  "Winpe Infographic Team presents a play of perspectives summarising key factors that contribute to the gender gap in the investing ecosystem.",
    ltitle: "Understanding Gender Gap in Investing | Diverse Perspectives",
    skey: "Winpe Infographic Team presents a play of perspectives summarising key factors that contribute to the gender gap in the investing ecosystem.",
    url: "/UnderstandingGenderGapinInvesting",
    imgUrl: icon12,
  },
  {
    id: 25,
    name: "",
    lname: " ",
    post: "",
    date: "22 October 2021",
    type: "INFOGRAPHICS",
    itype: [ "INFOGRAPHICS"],
    typee:  "This infographic analyses the state of funding for women-led businesses and the state of teams at leadership investing firms and start-ups.",
    ltitle: "The Inequitable State Of Enterprise And Investing | Taking Stock",
    skey: "This infographic analyses the state of funding for women-led businesses and the state of teams at leadership investing firms and start-ups.",
    url: "/TheInequitableStateOfEnterpriseAndInvesting",
    imgUrl: icon12,
  },
  {
    id: 25,
    name: "",
    lname: "Lavanya Ashok of Trifecta Capital",
    post: "",
    date: "8 October 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS"],
    typee:
      "Lavanya Ashok, Partner, Trifecta Capital",
    ltitle: "The Cheerleader with a Cheque-Book",
    skey:
      "Lavanya Ashok, Partner, Trifecta Capital",
    url: "/LavanyaAshok",
    imgUrl: icon15,
  },
  {
    id: 25,
    name: "",
    lname: "Nithya Easwaran of Multiples Alternate Asset Management",
    post: "",
    date: "24 September 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS"],
    typee:
      "Nithya Easwaran, Managing Director, Multiples Alternate Asset Management",
    ltitle: "The Winning Reset",
    skey:
      "Nithya Easwaran, Managing Director, Multiples Alternate Asset Management",
    url: "/NithyaEaswaran",
    imgUrl: icon15,
  },
  {
    id: 25,
    name: "",
    lname: "Neha Kant of Clovia",
    post: "",
    date: "10 September 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS"],
    typee:
      "Neha Kant, Founder & Director, Clovia",
    ltitle: "An Intimate Outreach",
    skey:
      "Neha Kant, Founder & Director, Clovia",
    url: "/NehaKant",
    imgUrl: icon15,
  },
  {
    id: 25,
    name: "",
    lname: "",
    post: "",
    date: "27 August 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    ltitle: "Editor's Pick | Advice for Women Entrepreneurs",
    typee:
      "The first edition of Winpe Insight's Editor's Pick dips into the library of candid conversations with seasoned investors and successful entrepreneurs to pull out nuggets of wisdom for aspiring women entrepreneurs. ",
    skey:
    "The first edition of Winpe Insight's Editor's Pick dips into the library of candid conversations with seasoned investors and successful entrepreneurs to pull out nuggets of wisdom for aspiring women entrepreneurs. ",
    url: "/TipsForEntrepreneurs",
    imgUrl: icon14,
  },
  {
    id: 25,
    name: "",
    lname: "Priya Rajan of Silicon Valley Bank",
    post: "",
    date: "13 August 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "Priya Rajan has been at the heart of global innovation for more than a decade, leading global finance operations for Silicon Valley Bank.",
    ltitle: "Vested in Innovation",
    skey:
    "Priya Rajan has been at the heart of global innovation for more than a decade, leading global finance operations for Silicon Valley Bank.",
    url: "/PriyaRajan",
    imgUrl: icon14,
  },
  {
    id: 25,
    name: "",
    lname: "Soumya Rajan of Waterfield Advisors",
    post: "",
    date: "30 July 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "Soumya Rajan was a banker who spotted an anomaly and launched a model that went against everything else in the market.",
    ltitle: "The Free Radical",
    skey:
      "Soumya Rajan was a banker who spotted an anomaly and launched a model that went against everything else in the market.",
    url: "/SoumyaRajan",
    imgUrl: icon13,
  },
  {
    id: 25,
    name: "",
    lname: "Mitchell Truwit of Apax",
    post: "",
    date: "16 July 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS", "INFOGRAPHICS"],
    typee:  "No one understands better than Mitch Truwit, the importance of building an investment firm with diversity and people at the heart.",
    ltitle: "Building an Investing Firm with Diversity at the Core",
    skey: "No one understands better than Mitch Truwit, the importance of building an investment firm with diversity and people at the heart.",
    url: "/MitchellTruwit",
    imgUrl: icon12,
  },
  {
    id: 25,
    name: "",
    lname: " Sushma Kaushik of Aavishkaar Capital ",
    post: "",
    date: "18 June 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "Sushma Kaushik is a well known face of impact investing in India.",
    ltitle: "The Venturous Investor",
    skey:
      "Sushma Kaushik is a well known face of impact investing in India.",
    url: "/SushmaKaushik",
    imgUrl: icon11,
  },
  {
    id: 25,
    name: "",
    lname: "Pearl Agarwal of Eximius Ventures",
    post: "",
    date: "04 June 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS"],
    typee:
      "Institutional investor turned solo capitalist, Pearl Agarwal",
    ltitle: "Extraordinary Soloist",
    skey:
      "Institutional investor turned solo capitalist, Pearl Agarwal",
    url: "/PearlAgarwal",
    imgUrl: icon10,
  },
  {
    id: 25,
    name: "",
    lname: "Ken Mehlman of KKR",
    post: "",
    date: "21 May 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS", "INFOGRAPHICS"],
    typee:
      " Ken Mehlman's understanding of diversity and inclusion is exceptionally nuanced.",
    ltitle: "With an Investor's Lens: Equity and Equality",
    skey:
      " Ken Mehlman's understanding of diversity and inclusion is exceptionally nuanced.",
    url: "/KenMehlman",
    imgUrl: icon10,
  },
  {
    id: 25,
    name: "",
    lname: "Bala C Deshpande of MegaDelta Capital",
    post: "",
    date: "04 May 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS"],
    typee:
      "Bala Deshpande is an investing icon in enterprise technology.",
    ltitle: "Quantum of Investing",
    skey:
      "Bala Deshpande is an investing icon in enterprise technology.",
    url: "/BalaCDeshpande",
    imgUrl: icon8,
  },
  {
    id: 25,
    name: "",
    lname: "Data Speak by Winpe Insights",
    post: "",
    date: "23 April 2021",
    type: "INFOGRAPHIC",
    itype: ["INFOGRAPHICS"],
    typee:
      "Women in Alternative Investments Data Speak by Winpe Insights 23 April 2021 INFOGRAPHIC",
    ltitle: "Women in Alternative Investments",
    skey:
      "Women in Alternative Investments Data Speak by Winpe Insights 23 April 2021 INFOGRAPHIC",
    url: "/womeninalternativeinvestments",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "Roshini Bakshi of Everstone Capital Asia",
    post: "",
    date: "09 April 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "Running Through Glass Ceilings Roshini Bakshi of Everstone Capital Asia 08 april 2021 Interview",
    ltitle: "Running Through Glass Ceilings",
    skey:
      "Running Through Glass Ceilings Roshini Bakshi of Everstone Capital Asia 08 april 2021 Interview",
    url: "/roshinibakshi",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "Anikiti Bose of Zilingo",
    post: "",
    date: "26 March 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS"],
    typee: "Powering Inroads Ambalika Banerji of NIIF 12 March 2021 VIDEOS",
    ltitle: "Millennial Mogul",
    skey: "Powering Inroads Ambalika Banerji of NIIF 12 March 2021 VIDEOS",
    url: "/ankitibose",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "Ambalika Banerji of NIIF",
    post: "",
    date: "12 March 2021",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS"],
    typee: "Powering Inroads Ambalika Banerji of NIIF 12 March 2021 VIDEOS",
    ltitle: "Powering Inroads",
    skey: "Powering Inroads Ambalika Banerji of NIIF 12 March 2021 VIDEOS",
    url: "/ambalikabanerji",
    imgUrl: icon1,
  },
 
  {
    id: 25,
    name: "",
    lname: "Alicorn Leadership Summit 2021",
    post: "",
    date: "21 January 2021",
    type: "VIDEO",
    itype: ["VIDEOS"],
    typee:
      "VIDEOS Upping the Stkes 10 December 2020 Alicorn Leadership Summit 2020",
    ltitle: "Upping the Stakes",
    skey:
      "10 December 2020 Alicorn Leadership Summit 2020 Upping the Stakes Upping the Stakes Video",
    url: "/uppingthestakes",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "Alicorn Leadership Summit 2021",
    post: "",
    date: "10 December 2020",
    type: "VIDEO",
    itype: ["VIDEOS"],
    typee:
      "VIDEOS Scale of Success 10 December 2020 Alicorn Leadership Summit 2020",
    ltitle: "Scale of Success",
    skey:
      "10 December 2020 Alicorn Leadership Summit 2021 Scale of Success Scale of Success Video",
    url: "/scaleofsuccess",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "Leadership Series by Winpe Insights ",
    post: "",
    date: "26 November 2020",
    type: "INFOGRAPHIC",
    itype: ["INFOGRAPHICS"],
    typee:
      "INFOGRAPHICS 26 November 2020 Gender, Leadership & Organisations Leadership Series by Winpe Insights",
    ltitle: "Gender, Leadership & Organisations",
    skey:
      "INFOGRAPHICS 26 November 2020 Gender, Leadership & Organisations Leadership Series by Winpe Insights",
    url: "/genderandleadership",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "Vineeta Singh  of SUGAR Cosmetics",
    post: "",
    date: "12 November 2020",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "INTERVIEWS Sweet Success Vineeta Singh  of Co-Founder & CEO of SUGAR Cosmetics",
    ltitle: "Sweet Success",
    skey:
      "INTERVIEW Sweet Success Vineeta Singh  of Co-Founder & CEO of SUGAR Cosmetics 12 November 2020",
    url: "/vineetasingh",
    imgUrl: icon9,
  },
  {
    id: 25,
    name: "",
    lname: "Zia J. Mody of AZB & Partners",
    post: "",
    date: "29 October 2020",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS"],
    typee:
      "INTERVIEWS Zia J. Mody of AZB & Partners 29 October 2020 All About Business",
    ltitle: "Diversity: Heads On",
    skey:
      "INTERVIEWS Zia J. Mody of AZB & Partners 29 October 2020 Diversity: Heads On",
    url: "/ziajmodyTwo",
    imgUrl: icon9,
  },
  {
    id: 25,
    name: "",
    lname: "Zia J. Mody of AZB & Partners",
    post: "",
    date: "15 October 2020",
    type: "INTERVIEW",
    itype: ["INTERVIEWS", "VIDEOS"],
    typee:
      "INTERVIEWS Zia J. Mody of AZB & Partners 15 October 2020 All About Business",
    ltitle: "All About Business",
    skey:
      "INTERVIEW Zia J. Mody of AZB & Partners 15 October 2020 All About Business",
    url: "/ziajmody",
    imgUrl: icon9,
  },
  {
    id: 25,
    name: "",
    lname: "Nupur Garg of Winpe",
    post: "",
    date: "01 October 2020",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "INTERVIEWS Delivering returns through diversified portfolios and diverse teams 3 September 2020 Anita M. George of CDPQ",
    ltitle: "Being the Change",
    skey: "INTERVIEWS Nupur Garg Being the change 01 october 2020",
    url: "/nupurgarg",
    imgUrl: icon9,
  },
  {
    id: 25,
    name: "",
    lname: "Renuka Ramnath of Multiples Alternate Asset Management",
    post: "",
    date: "17 September 2020",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "INTERVIEWS Delivering returns through diversified portfolios and diverse teams 3 September 2020 Anita M. George of CDPQ",
    ltitle: "Boardroom Strategies",
    skey:
      "INTERVIEW Boardroom Strategies Renuka Ramnath of Multiples Alternate Asset Management 17 September 2020",
    url: "/renukaramnath",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "Anita M. George of CDPQ",
    post: "",
    date: "3 September 2020",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "INTERVIEWS Delivering returns through diversified portfolios and diverse teams 3 September 2020 Anita M. George of CDPQ",
    ltitle:
      "Delivering returns through diversified portfolios and diverse teams",
    skey:
      "INTERVIEW Delivering returns through diversified portfolios and diverse teams  Anita M. George of CDPQ 3 September 2020",
    url: "/anitageorge",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "Leadership Series by Winpe Insights",
    post: "",
    date: "23 August 2020",
    type: "INFOGRAPHIC",
    itype: ["INFOGRAPHICS"],
    typee:
      "INFOGRAPHICS Networking & Leadership 23 August 2020 Leadership Series by Winpe Insights",
    ltitle: "Networking & Leadership ",
    skey:
      "INFOGRAPHIC Networking & Leadership  Leadership Series by Winpe Insights 23 August 2020",
    url: "/networkingandleadership",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "Vani Kola of Kalaari Capital ",
    post: "",
    date: "13 August 2020",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "INTERVIEWS Walking the Tightrope Vani Kola of Kalaari Capital 13 August 2020",
    ltitle: "Walking the Tightrope",
    skey:
      "INTERVIEW Walking the Tightrope Vani Kola of Kalaari Capital 13 August 2020",
    url: "/walkingthetightrope",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "Nisha Kaur Uberoi of Trilegal",
    post: "",
    date: "6 August 2020",
    type: "BLOG",
    itype: ["BLOGS"],
    typee:
      "BLOGS Merger Control Regime In India In Relation To Minority Investments 6 August 2020 Nisha Kaur Uberoi of Trilegal",
    ltitle:
      "Merger Control Regime In India In Relation To Minority Investments",
    skey:
      "BLOG Merger Control Regime In India In Relation To Minority Investments 6 August 2020 Nisha Kaur Uberoi of Trilegal",
    url: "/mergercontrolregime",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "Kirthiga Reddy of SoftBank Investment Advisers",
    post: "",
    date: "30 July 2020",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "INTERVIEWS The Superpower of AND 30 July 2020 Kirthiga Reddy of SoftBank Investment Advisers",
    ltitle: "The Superpower of AND",
    skey:
      "INTERVIEWS The Superpower of AND 30 July 2020 Kirthiga Reddy of SoftBank Investment Advisers",
    url: "/superpowerofand",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "Kirthiga Reddy of SoftBank Investment Advisers",
    post: "",
    date: "23 July 2020",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "INTERVIEWS When Businesses Succeed, Livelihoods Flourish 23 July 2020 Kirthiga Reddy of SoftBank Investment Advisers",
    ltitle: "When Businesses Succeed, Livelihoods Flourish",
    skey:
      "INTERVIEWS When Businesses Succeed, Livelihoods Flourish 23 July 2020 Kirthiga Reddy of SoftBank Investment Advisers",
    url: "/kirthigaReddypartone",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "The Next Normal Series by Winpe Insights",
    post: "",
    date: "16 July 2020",
    type: "INFOGRAPHIC",
    itype: ["INFOGRAPHICS"],
    typee:
      "INFOGRAPHICS Inclusive Leadership 16 July 2020 The Next Normal Series by Winpe Insights",
    ltitle: "Inclusive Leadership",
    skey:
      "INFOGRAPHICS Inclusive Leadership 16 July 2020 The Next Normal Series by Winpe Insights",
    url: "/inclusiveleadership",
    imgUrl: icon1,
  },
  {
    id: 25,
    name: "",
    lname: "Lizzie Chapman of ZestMoney",
    post: "",
    date: "9 July 2020",
    type: "BLOG",
    itype: ["BLOGS"],
    typee:
      "BLOGS Lizzie Chapman of ZestMoney 9 July 2020 Navigating Fundraising",
    ltitle: "Navigating Fundraising",
    skey: "BLOGs Lizzie Chapman of ZestMone 9 July 2020 Navigating Fundraising",
    url: "/navigatingfundraising",
    imgUrl: icon1,
  },
  {
    id: 24,
    name: "",
    lname: "The Next Normal Series by Winpe Insights",
    post: "",
    date: "2 July 2020",
    type: "INFOGRAPHIC",
    itype: ["INFOGRAPHICS"],
    typee:
      "INFOGRAPHICS The Next Normal Series by Winpe Insights 2 July 2020 Diversity at Risk Diversity at Risk Infographic",
    ltitle: "Diversity at Risk",
    skey:
      "Diversity at Risk Infographic The Next Normal Series by Winpe Insights 2 July 2020",
    url: "/diversityatrisk",
    imgUrl: icon2,
  },
  {
    id: 25,
    name: "",
    lname: "Manisha Girotra of Moelis & Company ",
    post: "",
    date: "25 June 2020",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "INTERVIEWS Manisha Girotra of Moelis & Company 25 June 2020 Holding My Own",
    ltitle: "Holding My Own",
    skey:
      "Holding My Own Manisha Girotra of Moelis & Company INTERVIEW 25 June 2020",
    url: "/holdingmyown",
    imgUrl: icon1,
  },
  {
    id: 24,
    name: "",
    lname: "The Next Normal Series by Winpe Insights",
    post: "",
    date: "18 June 2020",
    type: "INFOGRAPHIC",
    itype: ["INFOGRAPHICS"],
    typee:
      "INFOGRAPHICS The Next Normal Series by Winpe Insights Reimagining the Workplace",
    ltitle: "Reimagining the Workplace",
    skey:
      "Reimagining the Workplace The Next Normal Series by Winpe Insights Infographic 18 June 2020",
    url: "/reimaginingtheworkplace",
    imgUrl: icon2,
  },
  {
    id: 23,
    name: "",
    lname: "Padmaja Ruparel of Indian Angel Network",
    post: "",
    date: "11 June 2020",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "INTERVIEWS Padmaja Ruparel of Indian Angel Network Pivot or Perish: Keep Moving and Growing",
    ltitle: "Pivot or Perish: Keep Moving and Growing",
    skey:
      "Padmaja Ruparel of Indian Angel Network INTERVIEW Pivot or Perish: Keep Moving and Growing 11 June 2020",
    url: "/padmajaruparelofindianangelnetwork",
    imgUrl: icon3,
  },
  {
    id: 22,
    name: "",
    lname: "Alagappan Murugappan of CDC Group",
    post: "",
    date: "4 June 2020",
    type: "BLOG",
    itype: ["BLOGS"],
    typee:
      "BLOGS Alagappan Murugappan of CDC Group Changing Times: A DFI LP Perspective",
    ltitle: "Changing Times: A DFI LP Perspective",
    skey:
      "Alagappan Murugappan of CDC Group Changing Times: A DFI Perspective BLOGs 4 June 2020",
    url: "/changingtimesadfiperspective",
    imgUrl: icon4,
  },
  {
    id: 25,
    name: "",
    lname: "International Women's Day Series",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: ["VIDEOS"],
    typee: "International Women's Day Series 8 March 2021 VIDEOS",
    ltitle: "Celebrating Women in Investing",
    skey: "International Women's Day Series March 2021 VIDEOS",
    url: "/celebratingwomenininvesting",
    imgUrl: icon1,
  },
  {
    id: 21,
    name: "",
    lname: "Shweta Jalan of Advent International",
    post: "",
    date: "28 May 2020",
    type: "INTERVIEW",
    itype: ["INTERVIEWS"],
    typee:
      "INTERVIEWS Shweta Jalan of Advent International Learning never plateaus in PE",
    ltitle: "Learning never plateaus in PE",
    skey:
      "Shweta Jalan of Advent International INTERVIEW Learning never plateaus in PE 28 May 2020",
    url: "/shwetajalanofadventinternational",
    imgUrl: icon5,
  },
  {
    id: 0,
    name: "Bala C Deshpande",
    lname: "Bala C Deshpande of MegaDelta Capital",
    post: "Senior Managing Partner, MegaDelta Capital Advisors",
    date: "21 May 2020",
    type: "BLOG",
    itype: ["BLOGS"],
    typee: "BLOGS Bala C Deshpande of MegaDelta Capital The Stockdale Paradox",
    ltitle: "The Stockdale Paradox",
    skey:
      "Bala C Deshpande Senior Managing Partner, MegaDelta Capital Advisors The Stockdale Paradox BLOG",
    url: "/thestockdaleparadox",
    imgUrl: icon6,
  },
  {
    id: 1,
    name: "Nupur Garg",
    lname: "Nupur Garg of Winpe Forum",
    post: "Founder, Winpe Development Forum",
    date: "27 March 2020",
    type: "BLOG",
    itype: ["BLOGS"],
    typee: "BLOGS Nupur Garg of Winpe Forum My LP musings",
    ltitle: "My LP musings",
    skey: "Nupur Garg Founder Winpe Development Forum My LP musings BLOG",
    url: "/myLPmusings",
    imgUrl: icon7,
  },
 
 
  
  {
    id: 3,
    name: "",
    lname: "Taylor Lawrence of Everstone Group",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee: "aylor Lawrence of Everstone Group Ask and You Shall Get",
    ltitle: "Ask and You Shall Get",
    skey: "Ask and You Shall Get Taylor Lawrence EverStone Group ",
    url: "askandyoushallget/",
    imgUrl: icon8,
  },
  {
    id: 4,
    name: "",
    lname: "Anusha Shetty of Vaastu Finance",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee: "Anusha Shetty of Vaastu Finance Authenticity is Key",
    ltitle: "Authenticity is Key",
    skey: "Authenticity is Key Anusha Shetty Vaastu Finance",
    url: "authenticityiskey/",
    imgUrl: icon8,
  },
  {
    id: 5,
    name: "",
    lname: "Nisha Kaur Uberoi of Trilegal",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee: "Be Bold and Courageous Nisha Kaur Uberoi Trilegal",
    ltitle: "Be Bold and Courageous",
    skey: "Be Bold and Courageous Nisha Kaur Uberoi Trilegal ",
    url: "beboldandcourageous/",
    imgUrl: icon8,
  },
  {
    id: 6,
    name: "",
    lname: "Anshul Jain of Lighthouse Advisors",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee: "Battling Biases Anshul Jain Lighthouse Advisors",
    ltitle: "Battling Biases",
    skey: "Battling Biases Anshul Jain Lighthouse Advisors",
    url: "battlingbiases/",
    imgUrl: icon8,
  },
  {
    id: 7,
    name: "",
    lname: "Nidhi Prabhakar of Multiples Alternate Asset Management",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee:
      "Best of Both Worlds Nidhi Prabhakar Multiples Alternate Asset Management",
    ltitle: "Best of Both Worlds",
    skey:
      "Best of Both Worlds Nidhi Prabhakar Multiples Alternate Asset Management",
    url: "bestofbothworlds/",
    imgUrl: icon8,
  },
  {
    id: 9,
    name: "",
    lname: "RM Vishakha of India First Life Insurance",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee: "Empathy and Respect RM Vishakha India First Life Insurance",
    ltitle: "Empathy and Respect",
    skey: "Empathy and Respect RM Vishakha India First Life Insurance",
    url: "empathyandrespect/",
    imgUrl: icon8,
  },
  {
    id: 10,
    name: "",
    lname: "Hardika Shah of Kinara Capital",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee:
      "Financial Inclusion Powered by Gender Parity  Hardika Shah Kinara Capital",
    ltitle: "Financial Inclusion Powered by Gender Parity",
    skey:
      "Financial Inclusion Powered by Gender Parity  Hardika Shah Kinara Capital",
    url: "financialinclusionpoweredbygenderparity/",
    imgUrl: icon8,
  },
  {
    id: 11,
    name: "",
    lname: "Koel Kumar of Everstone Capital",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee: "Invest in Building Knowledge Koel Kumar EverStone Capital",
    ltitle: "Invest in Building Knowledge",
    skey: "Invest in Building Knowledge Koel Kumar EverStone Capital",
    url: "investinbuildingknowledge/",
    imgUrl: icon8,
  },
  {
    id: 12,
    name: "",
    lname: "Manju Dhawan of Ecom Express Pvt. Ltd.",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee:
      "Ecom Express Private Limited Making Inroads into Traditionally Male Industries Manju Dhawan",
    ltitle: "Making Inroads into Traditionally Male Industries",
    skey:
      "Ecom Express Private Limited Making Inroads into Traditionally Male Industries Manju Dhawan",
    url: "makinginroadsintotraditionallymaleindustries/",
    imgUrl: icon8,
  },
  {
    id: 13,
    name: "",
    lname: "Roshini Bakshi of Everstone Capital",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee: "My Life Lessons Roshini Bakshi EverStone Capital",
    ltitle: "My Life Lessons",
    skey: "My Life Lessons Roshini Bakshi EverStone Capital",
    url: "mylifelessons/",
    imgUrl: icon8,
  },
  {
    id: 14,
    name: "",
    lname: "Nupur Garg of Winpe Forum",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee: "Winpe Forum Sky Sans Ceilings Nupur Garg",
    ltitle: "Sky Sans Ceilings",
    skey: "Winpe Forum Sky Sans Ceilings Nupur Garg",
    url: "skysansceilings/",
    imgUrl: icon8,
  },
  {
    id: 15,
    name: "",
    lname: "Bhavna Thakur of Everstone Capital",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee: "Shattering Stereotypes Bhavna Thakur EverStone Capital",
    ltitle: "Shattering Stereotypes",
    skey: "Shattering Stereotypes Bhavna Thakur EverStone Capital",
    url: "shatteringstereotypes/",
    imgUrl: icon8,
  },
  {
    id: 16,
    name: "",
    lname: "Poonam Puri & Varsha Poddar of CDPQ",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee: "Together We Can Do It Varsha Poddar & Poonam Puri CDPQ",
    ltitle: "Together We Can Do It",
    skey: "Together We Can Do It Varsha Poddar & Poonam Puri CDPQ",
    url: "togetherwecandoit/",
    imgUrl: icon8,
  },
  {
    id: 17,
    name: "",
    lname: "Nithya Eeaswaran of Multiples Alternate Asset Management",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee:
      "The Likeability Bias Nithya Easwaran Multiples Alternate Asset Management",
    ltitle: "The Likeability Bias",
    skey:
      "The Likeability Bias Nithya Easwaran Multiples Alternate Asset Management",
    url: "thelikeabilitybias/",
    imgUrl: icon8,
  },
  {
    id: 2,
    name: "International Women’s Day Series ",
    lname: "International Women's Day Series",
    post: "",
    date: "8 March 2020",
    type: "VIDEO",
    itype: [],
    typee: "International Women's Day Series 8 March 2021 VIDEOS",
    ltitle: "Celebrating Women in Investing",
    skey: "International Women’s Day Series Celebrating Women in Investing VIDEOs",
    url: "/celebratingwomenininvesting",
    imgUrl: icon7,
  },
   
];

export { insightsConstants };



// WEBPACK FOOTER //
// ./src/constant/insights_constants.js